/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type fetchTradeDesignManagerOnboardingQueryVariables = {
    userId: string;
};
export type fetchTradeDesignManagerOnboardingQueryResponse = {
    readonly viewer: {
        readonly user: {
            readonly tradeFirmDesignManagerProfile: {
                readonly accountType: string | null;
            } | null;
        } | null;
    } | null;
};
export type fetchTradeDesignManagerOnboardingQuery = {
    readonly response: fetchTradeDesignManagerOnboardingQueryResponse;
    readonly variables: fetchTradeDesignManagerOnboardingQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "tradeFirmDesignManagerProfile",
  "storageKey": null,
  "args": null,
  "concreteType": "TradeFirmDesignManagerProfileType",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "accountType",
      "args": null,
      "storageKey": null
    }
  ]
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "fetchTradeDesignManagerOnboardingQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "fetchTradeDesignManagerOnboardingQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          },
          (v3/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "fetchTradeDesignManagerOnboardingQuery",
    "id": "app-buyer-finding/244.0.0-2019-12-12T16:17:40.900Z/fetchTradeDesignManagerOnboardingQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '93278d3a7603342664c83617f71efd11';
export default node;
